import axios from "./httpClient";

import { ApiType } from "./Types";
import { getUrl } from "./getURL";
import { ErrorMessages } from "../constants";
import { IMisDeliveryResponse } from "../models";
import { throwApiError } from "./apiError";

/**
 * GET API call using Axios
 * @returns - Array of Exception List of type IMisDeliveryResponse[]
 */

export const getMisDelivery = async (osdId: string): Promise<IMisDeliveryResponse> => {
  try {
    const response = await axios.get(`${getUrl(ApiType.MSD_VIEW)}/${osdId}`);
    return response.data;
  } catch (error: any) {
    return throwApiError(error, ErrorMessages.misDelivery);
  }
};
